// src/components/MyAppHeader.js
import React from "react";
import { Box, Typography } from "@mui/material";

export default function MyAppHeader() {
  return (
    <Box sx={{ py: 2, textAlign: "center" }}>
      <Typography variant="h5" fontWeight={600} color="primary">
        In Cooking
      </Typography>
    </Box>
  );
}
